import { render, staticRenderFns } from "./DashboardFilter.vue?vue&type=template&id=0d5e3a35&scoped=true"
import script from "./DashboardFilter.vue?vue&type=script&lang=js"
export * from "./DashboardFilter.vue?vue&type=script&lang=js"
import style0 from "./DashboardFilter.vue?vue&type=style&index=0&id=0d5e3a35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e3a35",
  null
  
)

export default component.exports